import { connectivityService } from '@/services/connectivityService'
import { showConfirm } from '@/services/dialogService'
import { logService, LOG_CATEGORIES } from '@/services/logService'
import { showError } from '@/services/toastService'

const OFFLINE_VIEW_ONLY_MESSAGE =
  'Offline mode is view-only for now. Modifications are disabled until Routecamp has a proper concept for offline change handling and sync reconciliation.'

export function isOfflineReadOnly(): boolean {
  return connectivityService.forceOfflineMode.value
}

export async function requireOnlineModificationAccess(action: string): Promise<boolean> {
  if (!isOfflineReadOnly()) return true

  logService.warn(LOG_CATEGORIES.UI, 'Blocked modification while offline', { action })

  await showConfirm({
    title: 'Offline Mode Is View-Only',
    message: OFFLINE_VIEW_ONLY_MESSAGE,
    confirmText: 'OK',
    variant: 'warning',
  })

  return false
}

export function throwIfOfflineReadOnly(action: string): void {
  if (!isOfflineReadOnly()) return

  logService.warn(LOG_CATEGORIES.UI, 'Blocked modification while offline', { action })
  showError(OFFLINE_VIEW_ONLY_MESSAGE)
  throw new Error(`OFFLINE_READ_ONLY:${action}`)
}
